var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cnt"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"div_loading"},[_c('van-loading',{attrs:{"type":"spinner","size":"24px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }